import { IonChip, IonItem, IonLabel } from "@ionic/react"
import dayjs from "dayjs"
import { startCase } from "lodash-es"
import { PatientFormStatusEnum } from "models/patient-phq/patient-form-status.enum"
import { PatientPHQSearchResponse } from "models/patient-phq/patient-phq.model"
import React from "react"
import Avatar from "react-avatar"

const colors: any = {
  [PatientFormStatusEnum.Unknown]: "danger",
  [PatientFormStatusEnum.Sent]: "secondary",
  [PatientFormStatusEnum.InProgress]: "primary",
  [PatientFormStatusEnum.Approved]: "success",
  [PatientFormStatusEnum.SubmitStarted]: "warning",
  [PatientFormStatusEnum.Submitted]: "success"
}

const PatientFormCard = (props: {
  form: PatientPHQSearchResponse
}) => {

    const getColor = (status: any) => {
      // console.log(status);
      return colors[status];
    }

    return (
      <IonItem key={props.form.PatientPHQID}>
      {/* <IonAvatar>
           <img width="400" height="400" src="https://mpng.subpng.com/20180411/rzw/kisspng-user-profile-computer-icons-user-interface-mystique-5aceb0245aa097.2885333015234949483712.jpg"/>
      </IonAvatar> */}
      <Avatar size="50" round name={props.form.FirstName + ' ' + props.form.LastName} />
      <IonLabel className="ml-1">
          <h3><b>{props.form.FirstName} {props.form.LastName}</b></h3>
          <p><b>MRN:</b> {props.form.MRN}</p>
      </IonLabel>
      <div>
           <IonChip disabled className="opacity-5" color={getColor(PatientFormStatusEnum[props.form.Status])}>{startCase(props.form.Status.toString())}</IonChip>
           <p className="text-center text-muted m-0" style={{fontSize: 'small'}}>{dayjs(props.form.UpdatedOn).format('MM/DD/YYYY')}</p>
      </div>
   </IonItem>
    )
}

export default PatientFormCard;